import React from "react";
import { Box } from "@mui/material";
import PriceBadge from "../PriceBadge";
import { formatCurrency, isNumber } from "../../../../../helpers";

interface PriceBadgesProps {
  buyBoxPrice?: number | null;
  avgFBMPrice?: number | null;
  avgFBAPrice?: number | null;
  avgBBPrice?: number | null;
  onPriceSelect: (value: number) => void;
}

const getBadgeColor = (
  price: number | null | undefined,
): "green" | "red" | "default" => {
  if (!isNumber(price)) {
    return "default";
  }
  return "green";
};

const formatBadgeLabel = (
  prefix: string,
  price: number | null | undefined,
): string => {
  if (!isNumber(price)) return `${prefix}: -`;
  return `${prefix}:${formatCurrency(price)}`;
};

export default function PriceBadges({
  buyBoxPrice,
  avgFBMPrice,
  avgFBAPrice,
  avgBBPrice,
  onPriceSelect,
}: PriceBadgesProps) {
  return (
    <Box display="flex" gap={0.75} mb="10px" flexWrap="wrap">
      <PriceBadge
        label={formatBadgeLabel("BB", buyBoxPrice)}
        color={getBadgeColor(buyBoxPrice)}
        onSelect={isNumber(buyBoxPrice) ? onPriceSelect : undefined}
        tooltip={
          isNumber(buyBoxPrice)
            ? "Current BuyBox Price. Click to update the selling price"
            : "Current BuyBox Price"
        }
      />
      <PriceBadge
        label={formatBadgeLabel("Avg FBM", avgFBMPrice)}
        color={getBadgeColor(avgFBMPrice)}
        onSelect={isNumber(avgFBMPrice) ? onPriceSelect : undefined}
        tooltip={
          isNumber(avgFBMPrice)
            ? "Current minimal FBM price. Click to update the selling price"
            : "Current minimal FBM price"
        }
      />
      <PriceBadge
        label={formatBadgeLabel("Avg FBA", avgFBAPrice)}
        color={getBadgeColor(avgFBAPrice)}
        onSelect={isNumber(avgFBAPrice) ? onPriceSelect : undefined}
        tooltip={
          isNumber(avgFBAPrice)
            ? "Current minimal FBA price. Click to update the selling price"
            : "Current minimal FBA price"
        }
      />
      <PriceBadge
        label={formatBadgeLabel("Avg BB", avgBBPrice)}
        color={getBadgeColor(avgBBPrice)}
        onSelect={isNumber(avgBBPrice) ? onPriceSelect : undefined}
        tooltip={
          isNumber(avgBBPrice)
            ? "90 days average price. Click to update the selling price"
            : "90 days average price"
        }
      />
    </Box>
  );
}
